<template>
  <div>
    <div class="album-group__container" v-show="showGroupTags">
      <div v-show="loading">
        <el-icon name="loading" class="album-group__loading"></el-icon>
      </div>
      <div
        v-show="!loading"
        v-for="groupTag in groupTags"
        :key="groupTag.id"
        class="album-group"
        :class="{ 'album-group--active': selectedGroupTag.id == groupTag.groupTagId }"
        @click="$emit('select-group-tag', groupTag)"
      >
        <div class="album-group__content">
          <div class="album-group__label">
            <div class="icon-container">
              <el-icon
                name="folder"
                class="icon-folder"
                :class="{
                  'icon-folder--active': selectedGroupTag.id == groupTag.groupTagId,
                }"
              ></el-icon>
            </div>
            <span
              class="album-group__name"
              :class="{
                'album-group__name--active': selectedGroupTag.id == groupTag.groupTagId,
              }"
            >
              {{ groupTag.groupTagName }}
            </span>
          </div>
          <el-popconfirm
            :title="
              !groupTag.groupTagId ? '是否要刪除未分類相簿內所有照片？' : '確定要刪除此相簿嗎?'
            "
            confirm-button-text="確認"
            cancel-button-text="取消"
            @confirm="$emit('delete-group-tag', groupTag.groupTagId)"
          >
            <div class="icon-container__delete" slot="reference">
              <el-icon name="delete" class="icon-delete"></el-icon>
            </div>
          </el-popconfirm>
        </div>
      </div>
    </div>

    <div v-if="albums && albums.length > 0" class="album-gallery" @scroll.passive="handleScroll">
      <el-checkbox-group
        v-if="showSelection"
        :value="selectedImageIds"
        @input="$emit('update:selectedImageIds', $event)"
      >
        <template v-for="album in albums">
          <el-checkbox v-for="file in album.files" :key="file.id" :label="file.id">
            <el-image class="imgs" :src="file.url"></el-image>
          </el-checkbox>
        </template>
      </el-checkbox-group>
      <template v-else>
        <template v-for="album in albums">
          <el-image
            v-for="file in album.files"
            :key="file.id"
            class="imgs"
            style="cursor: pointer"
            :src="file.url"
            @click="$emit('check-image', file.id)"
          ></el-image>
        </template>
      </template>
      <div class="album-gallery__load-more">
        <el-button
          v-if="hasMore"
          type="text"
          :loading="loadMoreLoading"
          @click="$emit('load-more')"
        >
          載入更多
        </el-button>
        <span v-else>已載入全部照片</span>
      </div>
    </div>
    <div v-else-if="loadMoreLoading" class="album-gallery__empty">
      <i class="el-icon-loading"></i>
      載入相簿中...
    </div>
    <div v-else class="album-gallery__empty">
      <span>查無資料</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlbumGallery',
  props: {
    albums: {
      type: Array,
      default: () => [],
    },
    groupTags: {
      type: Array,
      default: () => [],
    },
    selectedGroupTag: {
      type: Object,
      default: () => ({}),
    },
    selectedImageIds: {
      type: Array,
      default: () => [],
    },
    showSelection: {
      type: Boolean,
      default: false,
    },
    showGroupTags: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasMore: {
      type: Boolean,
      default: false,
    },
    loadMoreLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleScroll(event) {
      const container = event.target
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 80) {
        this.$emit('load-more')
      }
    },
  },
}
</script>

<style scoped>
.album-group__loading {
  font-size: 24px;
  color: #aaa9a9;
}

.album-group__content {
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
}

.album-group__label {
  display: flex;
  align-items: center;
  gap: 0 8px;
}

.album-gallery {
  max-height: 450px;
  overflow: auto;
}

.album-gallery__load-more {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 36px;
  color: #909399;
}

.album-gallery__empty {
  padding: 16px 0;
  text-align: center;
  color: #909399;
}

.imgs {
  width: 100px;
  height: 100px;
  margin: 0 8px 10px;
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ffd643 !important;
  border: 1px solid #ffd643 !important;
}

/deep/.el-checkbox__inner:hover {
  border-color: #ffd643;
}

/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #4b4b4b;
}

/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #ffd643 !important;
}

/deep/.el-checkbox__inner {
  width: 20px;
  height: 20px;
}

/deep/.el-checkbox__inner::after {
  height: 12px;
  left: 7px;
}

.album-group__container {
  display: flex;
  gap: 0 8px;
  padding-bottom: 24px;
  width: 95%;
  white-space: nowrap;
  overflow-x: scroll;
}

.album-group__container > .album-group {
  min-width: fit-content;
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
}

.album-group__container > .album-group:hover {
  opacity: 70%;
}

.album-group--active,
.album-group__name--active {
  color: #1890ff;
  font-weight: 700;
}

.icon-delete {
  color: #aaa9a9;
}

.icon-delete:hover {
  color: #c33f3f;
}
</style>
